<template>
    <div class="transfer-page" :class="theme">
        <div class="transfer-container ff-text flex flex-col w-full" :class="stage">
            <template v-if="isPageReady">
                <TopBar :theme="theme" :stage="stage" :lbl="lbl" @clickBack="clickTopBarBack()"></TopBar>
            </template>

            <template v-if="stage == 'tier'">
                <ConvertHeader :userProfile="landingFlow.states.profile" ref="convertHeader" v-bind="headerConfig"
                    :blobConfig="landingFlow.states.appConfig" :toApp="toApp" :stage="stage" :lbl="lbl"
                    @onClickLogin="loginTheOne()">
                </ConvertHeader>

                <TransferTier ref="transferTier" :stage="stage" :lbl="lbl" :objTier="pointTiersList"
                    @onClickTier="onClickTier">
                </TransferTier>
            </template>
            <template v-if="stage == 'result'">
                <TransferResult :userProfile="landingFlow.states.profile" :lbl="lbl" @onClickBack="clickBackCampaign()">
                </TransferResult>
            </template>

            <template v-if="isPageReady">
                <div class="wrapper-logo-bzb" :class="stage == 'init' ? 'black-bg' : 'white-bg'">
                    <img v-if="stage == 'init'" class="logo-bzb mx-auto" src="../assets/buzzebees-logo-white.svg" />
                    <img v-else class="logo-bzb mx-auto" src="../assets/buzzebees-logo.svg" />
                </div>
            </template>
        </div>

        <template v-if="isShowLogOut">
            <BtnLogout></BtnLogout>
        </template>
    </div>

    <ModalMaster :controller="modalController" />
</template>
<script>
import { computed, onMounted, provide } from "vue";
import { useRoute } from "vue-router";
import useModalStore from "../store/ModalStore"
import useLocaleStore from "../store/LocaleStore";
import useAccountStore from "../store/AccountStore"
import useModalSetup from "../composable/useModalSetup"
import LandingFlow from "../composable/LandingFlow";
import useAlertModal from "../composable/useAlertModal";
// helper
import Locale from "@/helper/locale/Locale";
import Util from "@/helper/Utility.js";
//component
import TopBar from "../component/TopBar/TopBar.vue";
import ModalMaster from "../component/Modal/ModalMaster.vue";
import ConvertHeader from "../component/Header/ConvertHeader.vue";
import TransferResult from "../component/Result/TransferResult.vue";
import TransferTier from "../component/Tier/Tier.vue";
// service
import useTheOne from "../composable/useTheOne";
import mongoService from "../../../service/mongoService";
//modal
import BtnLogout from "../component/Button/BtnLogout.vue";

export default {
    name: "TheOne",
    components: {
        TopBar,
        ConvertHeader,
        TransferTier,
        // Convert,
        // Result,
        TransferResult,
        ModalMaster,
        BtnLogout
    },
    setup: function () {
        const ModalStore = useModalStore();
        const LocaleStore = useLocaleStore()
        const AccountStore = useAccountStore()
        const route = useRoute()

        // setup modal
        useModalSetup(ModalStore)

        const { showApiErrorModal } = useAlertModal(ModalStore)

        const landingFlow = LandingFlow({
            mainAppName: "theone"
        },
            AccountStore,
            LocaleStore
        )
        const theOneService = useTheOne(landingFlow.states)

        const pointTiersList = computed(() => {
            let json = {}

            if (landingFlow.states.campaign != null) {
                // parse from customFacebookMessage
                json = JSON.parse(landingFlow.states.campaign.customFacebookMessage)
            } else {
                // for UI phase only
                json = {
                    point: [
                        // { Points: 10, Partner: 1000 },
                        // { Points: 20, Partner: 1000 },
                        // { Points: 1250, Partner: 1000 },
                        // { Points: 1250, Partner: 1000 },
                    ],
                }
            }

            return json
        })

        provide("ModalStore", ModalStore)
        provide("LocaleStore", LocaleStore)
        provide("AccountStore", AccountStore)
        provide("TheOneService", theOneService)

        onMounted(() => {
            if (route.query?.locale != null) {
                LocaleStore.setters.setLocale(route.query?.locale);
            }
        })

        return {
            modalController: ModalStore.methods.getModalController(),
            landingFlow,
            lbl: LocaleStore.lbl,
            isPageReady: landingFlow.isPageReady,
            pointTiersList,
            theOneService,
            showApiErrorModal
        }
    },
    data: function () {
        return {
            lblCode: Locale.getLocaleCode(),
            stage: "init",
            theme: "template_apiservice",
            isLoadedCampaign: false,
            theoneNumber: "",
        };
    },
    computed: {
        toApp: function () {
            return this.lbl.module.exchange_name;
        },
        fromApp: function () {
            return "Dtac";
        },
        headerConfig: function () {
            if (this.stage == "init" || this.stage == "result") {
                return {
                    showResult: this.stage == "result" ? true : false,
                    mode: this.stage == "result" ? "name" : "",
                    showCurrentPoint: false,
                };
            } else {
                return {
                    mode: "",
                    showCurrentPoint: true,
                };
            }
        },
        isShowLogOut: function () {
            if (this.theOneService.hasSignedIn.value && (this.stage == 'tier' || this.stage == 'result')) {
                return true
            }
            return false
        }
    },
    mounted: function () {
        this.init()
    },
    methods: {
        init: function () {
            // config landing flow
            this.landingFlow.events.onError = (err) => {
                console.log("init error", err)
                this.modalController.loadingModal.hide()
            }
            this.landingFlow.events.onReady = () => {
                // console.log("isPageReady", isPageReady)
                this.stage = "tier"
                // let loginResult = sessionStorage.getItem("t1c.loginResult")
                this.theOneService.initService()
                this.theOneService.methods.checkToken().then((resp) => {
                    // console.log(resp)
                    if (resp.success && resp.data?.data != null) {
                        this.theOneService.userTheOne.value = resp.data.data
                    }
                    this.theOneService.userPoints.value = resp.data?.points ?? 0
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    this.modalController.loadingModal.hide()
                })
            }

            // start initial
            this.modalController.loadingModal.show()
            this.landingFlow.init()
        },
        onClickTier: function (data) {
            // check has login
            if (!this.theOneService.hasSignedIn.value) {
                // call login
                this.loginTheOne()
                return
            }
            // console.log(data);
            this.landingFlow.states.selectTier = data.tier
            // stop timer then show otp
            this.modalController.transferConfirmModal
                .clearModal()
                .setBlobConfig(this.landingFlow.states.appConfig)
                .setTheoneProfile(this.theOneService.userTheOne.value)
                .setPoints(data.tier.Points, data.points)
                .show();

            this.modalController.transferConfirmModal.onClickOk(() => {
                // call redeem
                this.callRedeem()
            });
            // this.modalController.transferConfirmModal.onHidden((result) => {
            //     console.log(result);
            // });
        },

        //#region utility
        afterClickOkGotoCampaign: function () {
            this.modalController.alertModal.onClickOk(() => {
                window.location.replace(this.query.returnUrl);
            });
        },
        loginTheOne: function () {
            this.modalController.loadingModal.show()
            this.theOneService.methods.login().then((resp) => {
                console.log(resp)
                if (resp.success) {
                    // sessionStorage.removeItem("t1c.loginResult")
                    this.landingFlow.states.query.saveCache()

                    window.location.href = resp.data.UrlSSO
                } else {
                    console.log(resp)
                }
            }).catch((err) => {
                // show err
                console.log(err)
            }).finally(() => {
                this.modalController.loadingModal.hide()
            })
        },
        //#endregion

        //#region api
        callRedeem: function () {
            this.modalController.loadingModal.show()
            /**@type {import("@/core/QueryString/QueryStringDataModel").QueryStringDataModel} */
            let query = this.landingFlow.states.query
            /**@type {import("../composable/useTheOne").RedeemTheOneParams} */
            let redeemParams = {
                info1: query.info1,
                info2: query.info2,
                info3: query.info3,
                info4: query.info4,
                info5: query.info5,
                walletcard: query.walletCardId,
                points: this.landingFlow.states.selectTier.Points,
                withholdingtax_key: query.withholdingtax_key
            }
            var theme = this.landingFlow.states.query.theme || "";
            var appName = this.landingFlow.states.query.appName || theme || "";

            this.theOneService.methods.redeem(Util.cleanObjectEmptyStr(redeemParams)).then((res) => {
                console.log(res)
                var resp = res.data
                if (resp.success) {
                    if (resp.data?.successful == false) {
                        // has the one error
                        this.showApiErrorModal(this.lbl.errors.pointConversionError.title, { code: resp.data.error_code, message: resp.data.message }, {
                            errCode: resp.data.error_code,
                            msg: Util.stringFormat(this.lbl.errors.pointConversionError.message, this.landingFlow.states.appConfig.callcenter),
                            btnOk: this.lbl.base_button.close
                        }).onClickOk(() => {
                            this.$router.go()
                        })
                    } else {
                        // sucess then go to result page
                        this.theOneService.updatePoints(resp.data)

                        this.$nextTick(() => {
                            this.stage = "result"
                        })
                    }
                }
                mongoService.sendSuccessLogMongoDb(appName, theme, redeemParams, res);

            }).catch((err) => {
                // debugger
                let title = this.lbl.errors.somethingWrong.title
                let errMsg = this.lbl.errors.somethingWrong.message
                if(err.code == 1417){
                    errMsg = Util.stringFormat(this.lbl.errors.accountBlocked.message, this.landingFlow.states.appConfig.callcenter)
                } else if(err.code == 30000) {
                    title = this.lbl.errors.fullQuota.title
                    errMsg = this.lbl.errors.fullQuota.message
                }
                this.showApiErrorModal(title, err, {
                    errCode: err.code,
                    type: "bzbs",
                    msg: errMsg
                }).onClickOk((res) => {
                    // call redeem again
                    if (res.flag == 'try') {
                        // refresh page
                        this.$router.go()
                    }
                })
                mongoService.sendErrorLogMongoDb(err.err, redeemParams, appName, theme);
            }).finally(() => {
                this.modalController.loadingModal.hide()
            })
        },
        //#endregion

        //#region ui flow
        clickTopBarBack: function () {
            if (this.stage == "tier") this.clickBackCampaign();
            else if (this.stage == "result") this.refreshApp();
        },
        clickBackCampaign: function () {
            // console.log(this.query.returnUrl);
            // remove local storage
            if (!Util.isEmptyStr(this.landingFlow.states.query.returnUrl)) {
                window.location.replace(this.landingFlow.states.query.returnUrl);
            }
        },
        refreshApp: function () {
            this.$router.go()
        }
        //#endregion
    },
};
</script>
<style lang="scss">
@import "../style/main.scss";
</style>
<style lang="scss" scoped>
@import "../style/base.scss";


.transfer-page {
    background-color: #f4f4f4;
    color: $gray;
    @extend %base-class;

    .transfer-container {
        position: relative;
        width: 100%;
        margin: 0 auto;
        padding-bottom: 40px;
        min-height: 100vh;
        background-color: $bg-gray;

        &.result {
            background-color: #fff;
        }

        @include max-mobile {
            padding-bottom: 40px;
        }

        @include tablet {
            padding-bottom: 100px;
        }

        @include min-desktop {
            padding-bottom: 100px;
            max-width: 1200px;
        }

        .logout-theone {
            position: absolute;
            left: 0px;
            bottom: 60px;
            width: 100%;
            text-align: center;
            padding: 15px 0 15px 0;
            text-decoration: underline;
            text-decoration-color: white;
            text-underline-position: under;
            background-color: #0a0a0a;

            @include max-mobile {
                padding: 15px 0 15px 0;
            }

            @include tablet {
                padding: 40px 0 40px 0;
            }

            @include min-desktop {
                padding: 40px 0 40px 0;
            }


        }

        .white-bg {
            background-color: #ffffff;
        }

        .black-bg {
            background-color: #0a0a0a;
        }

        .wrapper-logo-bzb {
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            text-align: center;
            padding: 0px 0 16px 0;



            @include max-mobile {
                padding: 0px 0 24px 0;
            }

            @include tablet {
                padding: 0px 0 40px 0;
            }

            @include min-desktop {
                padding: 0px 0 40px 0;
            }

            .logo-bzb {
                height: 20px;
            }
        }
    }
}
</style>

